import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, apiErrorMessage } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="reset-password-missing-token">
        <SEO title="Choose a New A8A Password" description="Set a new password for your A8A account." noindex />
        <p className="text-destructive">This reset link is missing a token. Please request a new one.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="reset-password-page">
      <SEO title="Choose a New A8A Password" description="Set a new password for your A8A account." noindex />
      <form onSubmit={handleSubmit} className="w-full max-w-md space-y-5 border border-border p-8 bg-card">
        <h1 className="font-heading text-2xl font-medium text-foreground">Choose a new password</h1>
        <div>
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-new-input" />
        </div>
        <div>
          <Label htmlFor="confirmPassword">Confirm password</Label>
          <Input id="confirmPassword" type="password" required minLength={8} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} data-testid="reset-password-confirm-input" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="reset-password-error-message">{error}</p>}
        <Button type="submit" className="w-full h-11" disabled={loading} data-testid="reset-password-submit-button">
          {loading ? "Updating…" : "Update Password"}
        </Button>
        <p className="text-sm text-muted-foreground text-center">
          <Link to="/login" className="text-accent underline">Back to login</Link>
        </p>
      </form>
    </div>
  );
}
